
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 19a4 4 0 100-8 4 4 0 000 8z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37.45 29h-14.9c-.32 0-.574-.235-.548-.51.79-7.16 6.436-7.484 7.998-7.49 1.562.006 7.209.33 7.998 7.49.026.275-.227.51-.547.51z","fill":"#fff"}})])
          )
        }
      }
    